// Helper for the lowLimitAlert payload on VCN POST/PUT/PATCH requests
// (EX-39237). The feature is gated by the enable_low_balance_alert remote
// config flag; callers pass the flag value in so the field is omitted from
// the payload when the feature is off.

import type { VirtualCardFlatFormValues } from 'src/components/VirtualCardForm/VirtualCardForm'
import { toCents } from 'src/utils/currency.utils'

export type LowLimitAlertWriteShape = {
  alertEnabled: boolean
  amountThresholdCents: number | null
}

export function buildLowLimitAlert(
  flatFields: VirtualCardFlatFormValues,
  featureEnabled: boolean,
): LowLimitAlertWriteShape | undefined {
  if (!featureEnabled) return undefined
  const enabled = !!flatFields.lowBalanceAlertEnabled
  return {
    alertEnabled: enabled,
    amountThresholdCents:
      enabled && flatFields.lowBalanceThresholdDollars !== undefined
        ? toCents(flatFields.lowBalanceThresholdDollars)
        : null,
  }
}
